'use client'

import { useRightPanelContext } from './context.tsx'
import type { RightPanelId } from './context.tsx'

/** Targeted controls for one registered universal right panel. */
const useRightPanel = (id: RightPanelId) => {
  const { activePanelId, closePanel, open, openMobile, openPanel, togglePanel } =
    useRightPanelContext()

  return {
    closePanel: () => closePanel(id),
    isOpen: activePanelId === id && (open || openMobile),
    openPanel: () => openPanel(id),
    togglePanel: () => togglePanel(id),
  }
}

export { useRightPanel }
